import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Download } from 'lucide-react';
import { useExportJobs } from 'hooks/useExportJobs';
import PropTypes from 'prop-types';
import { Loader } from '@getro/rombo';
import { ToolbarButton } from 'components/molecules/agGrid/components/toolbarButton';
import OrganizationSchema from 'schemas/organization';

export const ExportJobs = ({ totalJobs, selectedJobs, selectAllJobs, company }) => {
  const { onExportClick, isExportingJobs } = useExportJobs({
    totalJobsInExport: totalJobs,
    origin: 'toolbar',
    selectedJobs,
    selectAllJobs,
    company,
  });

  return (
    <Box sx={{ pr: '16px' }}>
      {isExportingJobs ? (
        <Flex sx={{ alignItems: 'center', justifyContent: 'center', width: 'max-content', p: '8px' }}>
          <Loader size="small" />
        </Flex>
      ) : (
        <ToolbarButton
          option={{
            value: 'export',
            label: 'Export',
            icon: Download,
          }}
          toolbarOptionChange={() => onExportClick()}
          active={false}
          tooltip="Export a CSV of these filtered results to your inbox"
        />
      )}
    </Box>
  );
};

ExportJobs.propTypes = {
  totalJobs: PropTypes.number.isRequired,
  selectedJobs: PropTypes.array.isRequired,
  selectAllJobs: PropTypes.array.isRequired,
  company: OrganizationSchema,
};

ExportJobs.defaultProps = {
  company: null,
};
